module.exports = __webpack_public_path__ + "static/assets/18dada8a9aabcfc157e051d2e33aa7fd.png";